import React from 'react';
import { MdContentCopy } from 'react-icons/md';

/**
 * Check-in OTP banner — mirrors Flutter My Appointments + Appointment Details.
 * variant: 'strip' (list card) | 'box' (detail page) | 'dark' (inside card, app-style)
 */
export default function CheckInOtp({ otp, onCopy, variant = 'strip' }) {
  const code = String(otp || '').trim();
  if (!code) return null;

  const handleCopy = (e) => {
    e?.stopPropagation?.();
    onCopy?.(code);
  };

  if (variant === 'dark') {
    return (
      <div className="booking-otp-dark" onClick={handleCopy} role="button" tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && handleCopy(e)}>
        <span style={{ fontSize: 20 }}>🔐</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="booking-otp-dark-label">CHECK-IN OTP</div>
          <div className="booking-otp-dark-code">{code}</div>
          <div className="booking-otp-dark-hint">Show to hospital staff · Tap to copy</div>
        </div>
        <MdContentCopy size={18} color="#00d4aa" />
      </div>
    );
  }

  if (variant === 'box') {
    return (
      <div className="booking-otp-box" onClick={handleCopy} role="button" tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && handleCopy(e)}>
        <div className="booking-otp-label">🔐 CHECK-IN OTP</div>
        <div className="booking-otp-digits">
          {code.split('').map((d, i) => (
            <span key={i} className="booking-otp-digit">{d}</span>
          ))}
        </div>
        <div className="booking-otp-hint">Show to hospital staff at check-in · Tap to copy</div>
      </div>
    );
  }

  return (
    <div className="booking-otp-strip" onClick={handleCopy} role="button" tabIndex={0}
      onKeyDown={e => e.key === 'Enter' && handleCopy(e)}>
      <span>🔐</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 9, fontWeight: 800, color: '#00b894', letterSpacing: 1 }}>CHECK-IN OTP</div>
        <div className="booking-otp-strip-code">{code}</div>
        <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>Tap to copy · Tap card for full details</div>
      </div>
      <MdContentCopy size={16} color="#00b894" />
    </div>
  );
}
